import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

// Common for BS journey
import {
  LEQ_limit_enhance_API_CALL,
  LEQ_limit_enhance_API_CALL_extrareducer,
} from './le-questions/api/limit-enhance-starting-api';
import {
  LEQ_save_le_details_API_CALL_extrareducer,
  LEQ_save_le_details_API_CALL,
} from './le-questions/api/save-limit-enhance-details-api';

import { LEQ_updateCurrentScreenReducer } from './le-questions/functions/update-current-screen';
import { LEQ_updatePreviousScreenReducer } from './le-questions/functions/update-previous-screen';
import { LEQ_updateAckScreenDetailsReducer } from './le-questions/functions/update-ack-screen-details';
import { LEQ_updateLimitEnhanceDetailsReducer } from './le-questions/functions/update-limit-enhance-details';

import initialStateLEQuestionsState from './le-questions/le-questions-intial-state';
import {
  LEQ_auto_limit_enhance_API_CALL,
  LEQ_auto_limit_enhance_API_CALL_extrareducer,
} from './le-questions/api/auto-limit-enhance-api';

export const leQuestionsJourneySlice = createSlice({
  name: 'leQuestionsJourney',
  initialState: initialStateLEQuestionsState,
  reducers: {
    ...LEQ_updatePreviousScreenReducer,
    ...LEQ_updateCurrentScreenReducer,
    ...LEQ_updateAckScreenDetailsReducer,
    ...LEQ_updateLimitEnhanceDetailsReducer,
  },
  extraReducers: {
    ...LEQ_limit_enhance_API_CALL_extrareducer,
    ...LEQ_save_le_details_API_CALL_extrareducer,
    ...LEQ_auto_limit_enhance_API_CALL_extrareducer,
  },
});

export const {
  LEQ_updateCurrentScreen,
  LEQ_updatePreviousScreen,
  LEQ_updateAckScreenDetails,
  LEQ_updateLimitEnhanceDetails,
} = leQuestionsJourneySlice.actions;

export function useLEQuestionsStore() {
  const leQuestionsState = useSelector((state) => state.leQuestionsJourney);
  const currentScreen = useSelector(
    (state) => state.leQuestionsJourney.currentScreen
  );
  const previousScreen = useSelector(
    (state) => state.leQuestionsJourney.previousScreen
  );
  const limitEnhancementType = useSelector(
    (state) => state.leQuestionsJourney.limitEnhanceDetails.type
  );
  const limitEnhanceDetails = useSelector(
    (state) => state.leQuestionsJourney.limitEnhanceDetails
  );
  const ackScreenDetails = useSelector(
    (state) => state.leQuestionsJourney.ackScreenDetails
  );

  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    leQuestionsState,
    currentScreen,
    previousScreen,
    limitEnhancementType,
    ackScreenDetails,
    limitEnhanceDetails,

    // TODO: Write the sync action functions here
    updateCurrentScreen: (payload) =>
      dispatch(LEQ_updateCurrentScreen(payload)),
    updatePreviousScreen: (payload) =>
      dispatch(LEQ_updatePreviousScreen(payload)),
    updateAckScreenDetails: (payload) =>
      dispatch(LEQ_updateAckScreenDetails(payload)),
    updateLimitEnhanceDetails: (payload) =>
      dispatch(LEQ_updateLimitEnhanceDetails(payload)),

    // TODO: API calls or Async stuff here
    limit_enhance_API_CALL: (payload) =>
      dispatch(LEQ_limit_enhance_API_CALL(payload)),
    save_le_details_API_CALL: (payload) =>
      dispatch(LEQ_save_le_details_API_CALL(payload)),
    auto_limit_enhance_API_CALL: (payload) =>
      dispatch(LEQ_auto_limit_enhance_API_CALL(payload)),
  };
}

export default leQuestionsJourneySlice.reducer;
